module.exports = __webpack_public_path__ + "static/media/18.0443b4cd.jpg";